module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/4K External Video Conference Camera.e3b29f2c.png";